module.exports = __webpack_public_path__ + "img/s1_t1_06.0b41d794.jpeg";